import { useMemo } from "react";

import { FormProps } from "../../framework/react/FormProvider";
import { useFormDialog } from "../components/FormDialog";
import { PageFormItem, GroupFormItem, InfoFormItem, TextAreaFormItem } from "../components";

export enum AskForHelpFormIds {
    TextAreaMessage = "text-area-message",
}

export type AskForHelpForm =
    GroupFormItem<[
        InteractionPage,
        ConfirmPage
    ]>

type InteractionPage =
    PageFormItem<GroupFormItem<[
        InfoFormItem,
        TextAreaFormItem,
    ]>>

type ConfirmPage = PageFormItem<InfoFormItem>

export const useAskForHelpDialog = (onConfirm: FormProps<AskForHelpForm>["onSubmit"]) => {

    const form: AskForHelpForm = useMemo(() => {
        const interactionPage: InteractionPage = {
            type: "page",
            title: "Bed om hjælp",
            item: {
                type: "group",
                render: "all at once",
                items: [
                    {
                        type: "info",
                        render: "default",
                        text: `
                            Har du brug for hjælp, kan du altid komme i kontakt med os via denne formular. Vi svarer dig hurtigst muligt.
                        `,
                    },
                    {
                        id: AskForHelpFormIds.TextAreaMessage,
                        type: "text-area",
                        label: "Hvad har du brug for hjælp til?",
                        placeholder: "Fortæl os hvad vi kan hjælpe dig med",
                        value: "",
                        dirty: false,
                        validation: "mandatory",
                        hint: "Vær gerne så tydelig som muligt",
                    },
                ],
            },
        }
    
        const confirmPage: PageFormItem<InfoFormItem> = {
            type: "page",
            title: "Bed om hjælp",
            item: {
                type: "info",
                render: "default",
                text: `
                    Hvis du har bedt om hjælp for at kunne udføre dine opgaver, og du ikke hører fra os med det samme, skal du ikke bekymre dig.<br />
                    <br />
                    Vi glemmer dig ikke og vil vende tilbage til dig hurtigst muligt, senest inden for 2 arbejdsdage.
                `,
            },
        };

        return {
            type: "group",
            render: "all at once",
            items: [interactionPage, confirmPage],
        };
    }, []);

    return useFormDialog(form, onConfirm);
};
